import { useTranslation } from 'react-i18next';

import InfiniteSearchSelect from '@/components/shared/InfiniteSearchSelect';
import { Badge, SearchSelect } from '@/components/ui/daisy';
import { coursePathsQueryKeys } from '@/data/services/querykeys';
import CoursePath from '@/models/CoursePath';
import getFormatedCoursePathVersion from '@/utils/shared/getFormatedCoursePathVersion';

type CoursePathSelectProps = {
  value?: string;
  onChange: (coursePath: CoursePath | null) => void;
  className?: string;
};

export default function CoursePathSelect({
  value,
  onChange,
  className,
}: CoursePathSelectProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLessons.staff',
  });

  return (
    <SearchSelect.Fieldset aria-label={t('course')} className={className}>
      <InfiniteSearchSelect
        listService={coursePathsQueryKeys.list}
        getService={slug => coursePathsQueryKeys.get(String(slug))}
        getOptionValue={(coursePath: CoursePath) => coursePath.slug}
        getOptionLabel={(coursePath: CoursePath) => coursePath.course.name}
        renderOption={(coursePath: CoursePath) => (
          <span className="flex min-w-0 flex-1 items-center justify-between gap-2">
            <span className="min-w-0 break-words">
              {coursePath.course.name}
            </span>
            <CoursePathVersionBadge coursePath={coursePath} />
          </span>
        )}
        renderSelectedAddon={(coursePath: CoursePath) => (
          <CoursePathVersionBadge coursePath={coursePath} />
        )}
        value={value ?? null}
        onChange={onChange}
        placeholder={t('coursePlaceholder')}
      />
    </SearchSelect.Fieldset>
  );
}

type CoursePathVersionBadgeProps = {
  coursePath: CoursePath;
};

function CoursePathVersionBadge({ coursePath }: CoursePathVersionBadgeProps) {
  return (
    <Badge size="xs" variant="soft" className="shrink-0">
      {getFormatedCoursePathVersion({ coursePath })}
    </Badge>
  );
}
